import React from 'react'

const RadioChechedIcon = () => {
    return (
        <span style={{display:"flex"}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                <circle cx="12" cy="12" r="4" fill="white"/>
            </svg>
        </span>
    )
}

export default RadioChechedIcon;